<template lang="pug">
  lei-modal.modification-modal(@close="closeModal" title="Modification History" size="md")
    .wrapper
      template(v-if='!loading')
        .criteria-wrap
          modification-criteria(@enter="getModifications", @clear="clearFilter")
        changes-header(
          v-if="!emptyData"
          :showGroupTitle="false"
          )
          record-changes-wrap(
            v-for='(data, i) in modificationData'
            :key='i'
            :changesData="data")
        lei-info-label.modification-modal__no-data(
          v-else
          type="placeholder"
          text="No entity history available for selected filter")

      template(v-else)
        loading

      t-pagination(
        :current-page="pagination.currentPage",
        :last-page="pagination.lastPage",
        :per-page="pagination.perPage",
        @set-page="setPage",
        @next="setPage",
        @prev="setPage",
        @set-per-page="changePerPage",)

</template>

<script>
import { mapActions, mapMutations, mapState, } from 'vuex'
import { TOGGLE_CHANGES_MODAL, CHANGE_MODIFICATION_TYPE, RESET_CRITERIA_MODIFICATION, } from '@/store/modules/record/mutations-types'
import { parseModifications, } from '@/store/modules/record/helpers/parsing'
import _ from 'lodash'

import ModificationCriteria from '@/components/record-details/modifications/ModificationCriteria'
import RecordChangesWrap from '@/components/record-details/modifications/RecordChangesWrap'
import TPagination from '@/components/data-table/TPagination'
import LeiFilter from '@/components/lei-components/inputs/LeiFilter'
import LeiModal from '@/components/lei-components/LeiModal'
import Loading from '@/components/lei-components/Loading'
import ChangesHeader from '@/components/record-details/modifications/ChangesHeader'
import LeiInfoLabel from '@/components/lei-components/LeiInfoLabel'



export default {
  name: 'ChangesModal',
  components: {
    RecordChangesWrap,
    ModificationCriteria,
    TPagination,
    LeiFilter,
    LeiModal,
    Loading,
    ChangesHeader,
    LeiInfoLabel,
  },
  data () {
    return {
      modificationData: [],
      pagination: {},
      pageSize: 15,
    }
  },
  computed: {
    isPagination () {
      return Boolean(this.pagination)
    },
    currentPage () {
      return this.isPagination ? this.pagination.currentPage : 1
    },
    lastPage () {
      return this.isPagination ? this.pagination.lastPage : 1
    },
    perPage () {
      return this.isPagination ? this.pagination.perPage : 1
    },
    emptyData () {
      return _.isEmpty(this.modificationData)
    },

    ...mapState('record', [
      'criteriaModifications',
      'recordModifications',
      'modificationType',
      'loading',
    ]),
  },
  created () {
    this.getModifications()
  },
  beforeDestroy () {
    this.resetCriteriaModification()
  },
  methods: {
    closeModal () {
      this.toggleModal({ show: false, })
      this.changeModificationType(null)
    },
    getModifications (page = this.currentPage) {
      const id = this.$route.params.id
      this.getRecordModifications({
        id,
        type: this.modificationType,
        page: page,
        pageSize: this.pageSize,
        cb: this.parseModification,
      })
    },
    parseModification ({ data, meta, }) {
      this.modificationData = parseModifications(data)
      this.pagination = meta.pagination
    },
    setPage (page) {
      this.getModifications(page)
    },
    changePerPage (pageSize) {
      this.pageSize = pageSize
      this.getModifications(null)
    },
    clearFilter () {
      this.resetCriteriaModification()
      this.getModifications()
    },
    ...mapActions('record', [ 'getRecordModifications', ]),
    ...mapMutations('record', {
      toggleModal: TOGGLE_CHANGES_MODAL,
      changeModificationType: CHANGE_MODIFICATION_TYPE,
    }),
    ...mapMutations('record', {
      resetCriteriaModification: RESET_CRITERIA_MODIFICATION,
    }),
  },
}
</script>

<style scoped lang="stylus">
@import "../../assets/styles/variables.styl"
  .modification-modal
    .wrapper
      padding 0 20px

    .criteria-wrap
      width: 100%
      margin-bottom: 20px

    .filter-wrap
      padding-top: 20px
      margin: 0 auto
      max-width 370px
      width: 100%
      display: grid
      grid-template-columns: max-content 1fr
      grid-gap: 20px

      p
        align-self: center

      .filter
        position: relative
        bottom: 7px
        margin: 0
    &__no-data
      width 100%
      @media screen and (max-width: $tablet)
        font-size: 80%;

</style>



// WEBPACK FOOTER //
// src/components/modals/ChangesModal.vue